module.exports = __webpack_public_path__ + "img/6-5_Layout_Button.d3118c4b.png";